<div class="flex flex-d-c align-c justify-c {{app=='portal' ? 'min-h-es' : ''}}"
  *ngIf="VesselDataList.length === 0 && !loading ">
  <div *ngIf="app!=='portal'" class="flex flex-d-c align-c">
    <img loading="lazy" src="https://app.atmavaan.com/uploads/Empty_Container_svg_454_2024-05-07_04:47:34.svg"
      width="40%" class="mar-t-30-r">
    <div class="font-14 pad-tb-10 mar-t-5 width-res text-a-c">
      <div class="f-w-500 mar-b-10 font-16">No vessel schedule found for the selected criteria</div>
      <div class="mar-b-5">
        Please adjust your search parameters or WhatsApp us at
        <a href="https://api.whatsapp.com/send?phone=918925962780&text=Hi..I need a vessel schedule for this particular POL:{{getObj?.from}} and POD:{{getObj?.to}}"
          target="_blank">
          +91 8925 962 780</a> or email
      </div>
      <div>
        <a (click)="composeEmail()" href="" target="_blank">csindia{{'@'}}atmavaan.com</a> and we will revert back with
        availability.
      </div>
      <!-- <div class="mb-view"><a
          href="mailto:csindia@atmavaan.com?subject=Requesting to get a vessel schedule - reg&body=Port pairs that I have selected POL : {{getObj?.from}}, POD : {{getObj?.to}}"
          target="_blank">csindia{{'@'}}atmavaan.com</a> and we will revert back with availability.
      </div> -->
    </div>
  </div>

  <app-empty-state [type]="'vessel_schedule'" *ngIf="!VesselDataList.length && app=='portal'" [getObj]="getObj">
  </app-empty-state>
</div>

<div *ngIf="VesselDataList?.length > 0">
  <div class="mar-b-30 font-14 f-w-500  l-h-5 color-g" *ngIf="app!='portal' && type!='createbooking'">Vessel Schedules
  </div>
  <div *ngFor="let item of VesselDataList;index as indexas"
    class="{{type=='createbooking'?'':'border-c border border-r-4 mar-b-20-res mar-10-res bg-white'}} {{app=='portal' ? 'mar-t-20' : ''}}">
    <div class="flex justify-space-between pad-10" *ngIf="type!='createbooking'">
      <div class="{{app=='portal' ? 'dis-flex-p' : 'dis-flex'}} width-100">
        <div *ngFor="let data of vesselMetadata"
          class="{{indexas == 0 || indexas == 1 || indexas == 2 ? 'mar-b-10-res':''}} {{data.name == 'liner'?'flex align-c':''}} ">
          <div class="flex {{data.name == 'liner' ? 'align-c flex-d-c-res' :'flex-d-c'}}">
            <div *ngIf="data.name =='liner'" class="con-img">
              <img loading="lazy" *ngIf="!item?.liner?.logo"
              src="https://app.atmavaan.com/uploads/{{item?.liner?.container_icon}}" width="40px" height="20px"
              class="mar-r-10">
            <img loading="lazy" *ngIf="!!item?.liner?.logo"
              src="https://app.atmavaan.com/uploads/{{item?.liner?.logo}}" width="40px" height="40px"
              class="mar-r-10">
              <!-- <img loading="lazy" src="https://app.atmavaan.com/uploads/{{item?.liner.logo?item?.liner.logo:item?.liner.container_icon}}"
                width="60px" height="35px"> -->
            </div>
            <div class="sub-c mar-b-5 font-12">{{data.dname}}</div>
            <div class="flex align-c"
              *ngIf="data.name != 'liner' && data.type !=='date' && data.name !== 'vessel_name'">
              {{item[data.name] ? item[data.name] : '---'}}
              <div *ngIf="data.name ==='transits_days'">&nbsp; {{item[data.name] ? 'days' : ''}}</div>
            </div>
            <div class="flex align-c"
              *ngIf="data.name != 'liner' && data.type ==='date' && data.name !== 'vessel_name'">
              {{item[data.name] ? (item[data.name] | date) : '---'}}
            </div>
            <div class="flex align-c" *ngIf="data.name === 'liner'">
              {{item[data.name] ? item[data.name]?.name : '---'}}
            </div>
            <div class="flex align-c" *ngIf="data.name === 'vessel_name'">
              {{item[data.name] ? item[data.name]?.value : '---'}}
            </div>
          </div>
        </div>
      </div>
      <div class="flex align-b justify-space-between mar-t-45px">
        <div *ngIf="app=='portal'" class="flex align-c justify-c">
          <span class="pointer primary-c f-w-500 font-12 wid-m mar-r-30-res" (click)="expand(indexas)">
            {{!viewvessel[indexas] ? 'View Timeline' : 'Hide Timeline'}}
          </span>
        </div>
        <div *ngIf="app=='portal'" class="flex align-c justify-r-res">
          <div class="desk-view">
            <button mat-button class="bg-primary white font-12" style="min-width: 96px;"
              (click)="selectedDataDialog(rateSearchTemplate,item)">View Rates</button>
          </div>
          <div class="mb-view">
            <button mat-button class="bg-primary white font-12" style="min-width: 96px;"
              (click)="selectedDataSheet(rateSearchTemplate,item)">View Rates</button>
          </div>
        </div>
      </div>
      <!-- <mat-icon class="pointer primary-c" (click)="expand(indexas)">{{!viewvessel[indexas] ?
                'expand_more' : 'expand_less'}}</mat-icon> -->
      <span *ngIf="app!='portal'" class="pointer primary-c f-w-600 material-symbols-outlined" (click)="expand(indexas)">
        {{!viewvessel[indexas] ? 'expand_more' : 'expand_less'}}
      </span>
    </div>
    <div *ngIf="viewvessel[indexas] || type === 'createbooking'">
      <div class="{{type=='createbooking'?'':'pad-10 mar-t-10 overflow-a vesl-h'}} ">
        <div class="bg-white pad-10 border-r-4 font-14">
          <ng-container *ngTemplateOutlet="timeline;context:{item:item,indexas:indexas,pType:'main'}"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #rateSearchTemplate>
  <div class="pad-10 border-b border-c flex align-c justify-space-between">
    <div class="head-c font-16 f-w-500 pad-l-10">Rate Search</div>
    <button class="icon-btn-basic" (click)=" close()">
      <mat-icon class="font-22">close</mat-icon>
    </button>
  </div>
  <div class="pad-10 border-b border-c">
    <div class="pad-10 flex justify-space-between">
      <div class="grid grid-tem-rate grid-gap-20">
        <div>
          <div class="head-c f-w-500 font-12">{{queryParamsData?.origin?.location_name}}
            ({{queryParamsData?.origin?.location_code}}) - {{queryParamsData?.origin?.country_code}}</div>
          <div class="sub-c font-12">Est Departure :
            {{rateSearch?.departure_date ? (rateSearch?.departure_date | date) : '---'}} </div>
        </div>
        <mat-icon><span class="material-symbols-outlined">arrow_right_alt</span></mat-icon>
        <div>
          <div class="head-c f-w-500 font-12">{{queryParamsData?.destination?.location_name}}
            ({{queryParamsData?.destination?.location_code}}) - {{queryParamsData?.destination?.country_code}}
          </div>
          <div class="sub-c font-12">Est Arrival :
            {{rateSearch?.arrival_date ? (rateSearch?.arrival_date | date) : '---'}}</div>
        </div>
      </div>
      <span class="primary-c font-12 f-w-500 pointer mar-l-10 nowrap"
        (click)="rateSearch['is_view'] = !rateSearch['is_view']">
        {{!rateSearch?.is_view ?'View Timeline' : 'Hide Timeline'}}
      </span>
    </div>
    <div class="pad-10 flex align-c">
      <div *ngIf="!!rateSearch?.vessel_name" class="bg-vessel pad-5-10 mar-r-10 border-r-4 flex align-c">
        <span class="material-symbols-outlined mar-r-5 font-18">directions_boat</span>
        <div class="head-c font-12 primary-c f-w-500">{{rateSearch?.vessel_name?.value}}</div>
      </div>
      <div *ngIf="!!rateSearch?.transits_days" class="bg-liner pad-5-10 mar-r-10 border-r-4 head-c font-12 f-w-500">
        {{rateSearch?.transits_days}} Days</div>
      <div *ngIf="!!rateSearch?.liner" class="bg-liner pad-5-10 border-r-4 head-c font-12 f-w-500">
        {{rateSearch?.liner?.name}}</div>
    </div>
  </div>
  <div class="pos-r width-100" *ngIf="!!isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div *ngIf="!!rateSearch?.is_view " class="{{type=='createbooking'?'':'border-b border-c'}} ">
    <div class="bg-timeline pad-10 border-r-4 font-14 overflow-a h-300">
      <ng-container *ngTemplateOutlet="timeline;context:{item:rateSearch,pType:'pop'}"></ng-container>
    </div>
  </div>
  <div class="pad-10 height-rate overflow-a bg-default">
    <div class="pad-10 sub-c font-12 flex align-c justify-space-between">
      <div>Please select a rate to proceed with booking</div>
      <div>Total rates : <span class="f-w-500">{{!!rateList?.rates ? rateList?.rates.length : 0}}</span></div>
    </div>
    <div *ngIf="!!(rateList?.rates && rateList?.rates.length)">
      <div *ngFor="let rate of rateList.rates" class="border border-c border-r-4 margin-10 bg-white">
        <div class="grid grid-temp-col pad-10">
          <div class="mar-t-5">
            <img src="https://app.atmavaan.com/uploads/{{rate?.liner?.icon}}" width="50px">
          </div>
          <div class="font-12">
            <div class="head-c f-w-500">{{rate?.liner?.liner_name}}</div>
            <div class="sub-c">{{rate?.container?.value}} - {{rate?.cargo_type}}</div>
          </div>
          <div class="font-12">
            <div class="sub-c">Rate Validity</div>
            <div class="head-c">{{rate?.effective_date | date}} to {{rate?.rate_validity | date}}</div>
          </div>
          <div class="">
            <div class="flex align-c">
              <div class="mar-r-10">USD </div>
              <div class="flex align-c pointer" (click)="rate['is_charge'] = !rate['is_charge']" style="color: green;">
                <span class="f-w-500 mar-r-10 flex align-c">${{rate?.total_freight?.toLocaleString()}}<mat-icon
                    class="font-22">{{!rate['is_charge']
                    ? 'expand_more':'expand_less'}}</mat-icon> </span>
              </div>
            </div>
            <div class="sub-c font-12">Ocean Freight</div>
          </div>
        </div>
        <div class="grid grid-temp-col pad-10">
          <div></div>
          <div class="font-12">
            <div class="sub-c">Transit Time</div>
            <div class="head-c">{{rate?.transit_time}} days</div>
          </div>
          <div class="font-12">
            <div class="sub-c">Routing</div>
            <div class="head-c">{{rate?.routing}}</div>
          </div>
          <div>
            <button class="font-12 nowrap" mat-stroked-button color="primary" style="padding: 10px;"
              (click)="openConfirmationDialog(confirmTemplate,rate)"> Select Rate </button>
          </div>
        </div>
        <div *ngIf="!!rate['is_charge']" class="pad-20 border-t border-c">
          <div class="pad-16 border-c border-b" *ngIf="!!rate?.liner_id && !!chargeListObj.freight_charge[rate?.liner_id] ">
            <div class="f-w-500 mar-b-10 font-12">Freight Charges</div>
            <div
              *ngFor="let cost of chargeListObj.freight_charge[rate?.liner_id] "
              class="grid grid-gap-5 grid-a-30-40 pad-tb-10 font-12 {{!rate[cost?.column_name]?'display-none':''}}">
              <div class="overflow-e sub-c">{{cost?.charge_head_expansion}}</div>
              <div class="sub-c">{{cost?.currency && cost?.currency?.value?cost?.currency?.value:'---'}}</div>
              <div class="text-a-e">{{rate[cost?.column_name]}}</div>
            </div>
            <div *ngIf="!!rate?.other_charges" class="grid grid-gap-5 grid-a-30-40 pad-tb-10 font-12 ">
              <div class="overflow-e sub-c">{{rate?.other_charges_header}}</div>
              <div class="sub-c">USD</div>
              <div class="text-a-e">{{rate?.other_charges}}</div>
            </div>
          </div>
          <div class="pad-16 border-c border-b" *ngIf="!!rate?.liner_id && !!chargeListObj.origin_charge[rate?.liner_id] ">
            <div class="f-w-500 mar-b-10 font-12">Origin Charges</div>
            <div
              *ngFor="let cost of chargeListObj.origin_charge[rate?.liner_id] "
              class="grid grid-gap-5 grid-a-30-40 pad-tb-10 font-12 {{!rate[cost?.column_name]?'display-none':''}}">
              <div class="overflow-e sub-c">{{cost?.charge_head_expansion?.replace('Others Charge Origin','Other Origin Charges')}}</div>
              <div class="sub-c">{{cost?.currency && cost?.currency?.value?cost?.currency?.value:'---'}}</div>
              <div class="text-a-e">{{rate[cost?.column_name]}}</div>
            </div>
          </div>
          <div class="pad-16 border-c border-b" *ngIf="!!rate?.liner_id && !!chargeListObj.destination_charge[rate?.liner_id] ">
            <div class="f-w-500 mar-b-10 font-12">Destination Charges</div>
            <div
              *ngFor="let cost of chargeListObj.destination_charge[rate?.liner_id] "
              class="grid grid-gap-5 grid-a-30-40 pad-tb-10 font-12 {{!rate[cost?.column_name]?'display-none':''}}">
              <div class="overflow-e sub-c">{{cost?.charge_head_expansion?.replace('Others Charge Destination','Other Destination Charges')}}</div>
              <div class="sub-c">{{cost?.currency && cost?.currency?.value?cost?.currency?.value:'---'}}</div>
              <div class="text-a-e">{{rate[cost?.column_name]}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="(!!rateList?.rates && !rateList?.rates.length) || rateList?.rates == null"
      class="flex align-c justify-c h-90">
      <div *ngIf="!isLoading">
        <app-empty-state [type]="'rate_search_vessel'"></app-empty-state>
        <div class="flex align-c justify-c mar-tb-10">
          <div class="desk-view">
            <button mat-stroked-button color="primary" class="border-primary"
              (click)="openRateRequestDialog(requestRateTemplate)">Request a Rate</button>
          </div>
          <div class="mb-view">
            <button mat-stroked-button color="primary" class="border-primary"
              (click)="openRateRequstBottomSheet(requestRateTemplate)">Request a Rate</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #timeline let-item="item" let-indexas="indexas" let-pType="pType">
  <div *ngFor="let schedule of item.schedule;index as parentIndexAs">
    <div class="grid grid-gap-10 {{type=='createbooking'?'grid-cb-tem':'grid-t-50-50'}} {{pType=='main' ? 'grid-t-50-50' : ''}} {{pType=='pop' ? 'grid-tp-50-50' : ''}}
      {{events.event_type == 'arrival' ? 'pad-t-10' : ''}}" *ngFor="let events of schedule.events;let i = index">
      <div class="text-a-e">
        <div class="head-c font-14">
          <div class="f-w-500" *ngIf="i==0">
            <span>{{schedule?.port_info?.name ? schedule?.port_info?.name : '---'}}</span>
          </div>
        </div>
      </div>
      <div class=" flex flex-d-c  align-c">
        <div class="pad-5 flex align-c justify-c">
          <img loading="lazy" src="https://app.atmavaan.com/uploads/mynaui_boat_svg_454_2024-04-21_04:35:17.svg"
            alt="">
        </div>
        <div *ngIf="!(parentIndexAs === item.schedule.length - 1 && i === schedule.events.length - 1)"
          class="{{events.event_type == 'departure'&& events.date != null ? 'height-90' : 'height-70'}}">
        </div>
        <div
          class="pad-5 flex align-c justify-c pos-r {{getDaysDifference(schedule.events[0].date,schedule.events[1].date) >= 1 ? 'left-50' :'left-20'}}"
          *ngIf="!(parentIndexAs === item.schedule.length - 1 && i === schedule.events.length - 1) && events.event_type !== 'departure' && !!schedule?.events[0]?.date && !!schedule?.events[1]?.date">
          <div class="pos-a flex">
            <div class="wid-m mar-r-10 day-c font-14"
              *ngIf="getDaysDifference(schedule.events[0].date,schedule.events[1].date) >= 1">
              {{getDaysDifference(schedule.events[0].date, schedule.events[1].date)}}
              {{getDaysDifference(schedule.events[0].date, schedule.events[1].date) > 1 ?'days' : ''}}</div>
            <img loading="lazy"
              src="https://app.atmavaan.com/uploads/hourglass_FILL0_wght300_GRAD0_opsz24_1_svg_454_2024-04-21_04:35:38.svg"
              alt="">
          </div>
        </div>
      </div>
      <div class="">
        <div class="head-c font-14">
          <span class="f-w-500 text-t-c">Est {{events?.event_type ? events?.event_type : '---'}}</span>
          <div class="mar-t-5 font-12 ">
            <span>{{events?.date ? (events?.date | date) : '---'}}</span>
          </div>
        </div>
        <div class="d-f mar-tb-10 dep-b chip-bg" *ngIf="events.event_type === 'departure'">
          <div class="mar-b-st-10">
            <div class="sub-c font-12">Vessel</div>
            <div class="text-t-c">{{events?.vessel_name ? events?.vessel_name?.value : '---'}}
            </div>
          </div>
          <div class="mar-b-st-10">
            <div class="sub-c font-12">Voyage</div>
            <div>{{events?.voyage_no ? events?.voyage_no : '---'}}</div>
          </div>
          <div>
            <div class="sub-c font-12">Service Lane</div>
            <div>{{events?.service_lane ? events?.service_lane?.value : '---'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #confirmTemplate>
  <div class="pad-10 flex align-c justify-space-between border-b border-c">
    <div class="haed-c font-16 pad-l-10 f-w-500">Create Booking</div>
    <button class="icon-btn-basic" (click)="bookingRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="pad-20 pad-b-0-res">Review and confirm the rate and vessel</div>
  <div class="pad-20 can-c">
    <button mat-stroked-button color="primary" class="width-100px mar-b-10-res"
      (click)="bookingRef.close()">Cancel</button>
    <button mat-flat-button color="primary" class="mar-l-10-res width-100px" (click)="createBook(loginCompTemplate)">Create
      Booking</button>
  </div>
</ng-template>

<ng-template #requestRateTemplate>
  <app-rate-request-dialog [inputObj]="rateFromtoObj" (closeEmit)="closeRequest()">
  </app-rate-request-dialog>
</ng-template>

<ng-template #loginCompTemplate>

  <div class="flex flex-d-c align-c justify-c" style="position: relative;">
    <div class="h-btn">
      <button class="icon-btn-basic" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <!-- <app-login [useType]="'popup'" *ngIf="authType=='login'" (changeEmit)="loginHandle($event,templateLogin)">
    </app-login> -->
    <common-login [useType]="'popup'" *ngIf="authType=='login'" (changeEmit)="loginHandle($event,loginCompTemplate)">
    </common-login>
  </div>

</ng-template>
